import { Card, H2 } from '../ui.jsx';
import { C } from '../lib/format.js';
import { MO } from '../lib/finance.js';

export default function Tracker({ s, tracker }) {
  return (
    <Card>
      <H2 sub="10-year projection (120 months) · end-of-month balances · scroll within the sheet (header stays fixed)">
        Month-by-Month Savings Tracker
      </H2>
      <div className="scroll-x scroll-y" style={{ maxHeight: '72vh' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, minWidth: 700 }}>
          <thead>
            <tr>
              {['Month', 'Events', 'James PB', 'Joanne PB', 'James ISA', 'Joanne ISA', 'J Pension', 'O Pension', 'Total'].map((h, i) => (
                <th key={h} style={{
                  padding: '10px 10px', textAlign: i < 2 ? 'left' : 'right', color: C.lbl, fontWeight: 500,
                  fontSize: 10, textTransform: 'uppercase', letterSpacing: .5, whiteSpace: 'nowrap',
                  position: 'sticky', top: 0, background: C.card, borderBottom: `2px solid ${C.bdr}`, zIndex: 1,
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tracker.map((d, idx) => {
              const ev = [];
              if (!s.mortgageCleared && d.year === (s.mortgageClearYear || 2026) && d.month === (s.mortgageClearMonth || 10)) ev.push('🏠 Mortgage cleared');
              if (s.inheritancePending && d.year === (s.inheritanceYear || 2026) && d.month === (s.inheritanceMonth || 12)) ev.push('💰 Inheritance → cash ISA');
              if (d.month === 4 && d.year >= 2027) ev.push('📈 Apr pension top-up');
              const hi = ev.length > 0;
              const newYear = d.month === 1;
              return (
                <tr key={d.i} style={{
                  borderBottom: `1px solid ${C.bdr}`,
                  borderTop: newYear ? `2px solid ${C.steel}55` : 'none',
                  background: hi ? C.gold + '0D' : idx % 2 === 0 ? C.surf + '55' : 'transparent',
                }}>
                  <td style={{ padding: '9px 10px', fontFamily: "'DM Mono',monospace", fontWeight: 600, color: C.bright, whiteSpace: 'nowrap' }}>
                    {MO[d.month]} {d.year}
                  </td>
                  <td style={{ padding: '9px 10px', fontSize: 10, color: C.gold, whiteSpace: 'nowrap' }}>{ev.join(' · ')}</td>
                  {[d.jPB, d.oPB, d.jISA, d.oISA, d.jPen, d.oPen, d.total].map((v, vi) => (
                    <td key={vi} style={{
                      padding: '9px 10px', textAlign: 'right', fontFamily: "'DM Mono',monospace", fontSize: 12,
                      color: vi === 6 ? C.gold : C.text, fontWeight: vi === 6 ? 600 : 400,
                    }}>£{Math.round(v).toLocaleString('en-GB')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
